import { Component, ViewContainerRef } from '@angular/core';
import { OverlayHostService } from '../../services/overlay-host/overlay-host.service';

/**
 * The OverlayHostComponent is a placeholder component which provides a location in the DOM into which overlay
 * elements (modals, notify notifications etc) may be injected dynamically.
 */
@Component({
    selector: 'app-overlay-host',
    template: '<!-- -->',
    standalone: true,
    imports: []
})
export class OverlayHostComponent {
    constructor(viewContainerRef: ViewContainerRef, overlayHostService: OverlayHostService) {
        overlayHostService.registerHostView(viewContainerRef);
    }
}
